var React = require('react');

function Explore (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},React.createElement("g",{"fill":"#434343"},React.createElement("path",{"d":"M15 6H1c-.6 0-1 .4-1 1s.4 1 1 1h14c.6 0 1-.4 1-1s-.4-1-1-1zM15 0H1C.4 0 0 .4 0 1s.4 1 1 1h14c.6 0 1-.4 1-1s-.4-1-1-1zM15 12H1c-.6 0-1 .4-1 1s.4 1 1 1h14c.6 0 1-.4 1-1s-.4-1-1-1z"}))));
}

Explore.defaultProps = {"width":"16","height":"14","viewBox":"0 0 16 14"};

module.exports = Explore;

Explore.default = Explore;
